export default {
  Consultations: 'Consultations',
  consultations: 'Consultation',
  consultation: 'Nouvelle consultation',
  'consultations.proposed_terms': 'Dates proposées',
  'consultations.calendar': 'Calendrier',
  'consultations.screenSaves': 'Captures d’écran',
  'consultations.edit': 'Modifier la consultation',
  'consultations.duration_tooltip':
    'Durée de la consultation en heures, minutes, secondes, jours, semaines, mois ou un an. Exemples : 2 heures, 20 minutes, 1 jour ou 1 heure et 30 minutes combinées.',
};
